import { useMemo } from 'react'

import { Button, Checkbox, Flex } from 'antd'
import { createStyles } from 'antd-style'

import { TemplateVariableEntity } from '@eastcoal/api/contract/interface'

import {
  connect,
  mapReadPretty,
  useExpressionScope,
  useForm
} from '@eastcoal/formily/exports/react'
import { FormilyProps } from '@eastcoal/formily/types/component'

import { TableVariableNodeVariableChild } from '../../../../../editor/nodes/TableVariableNode/interface'

const useStyles = createStyles(({ token }) => ({
  button: {
    height: 'auto',
    paddingBlock: 0,
    paddingInline: token.paddingXXS
  }
}))

const Component = ({ value, onChange, ...formilyProps }: FormilyProps) => {
  const form = useForm()
  // 原始的变量，与之相对应的是 Node 节点中的 variable 变量
  // 在配置变量时根据 globalVariableData 生成表单，表单更改时同步 Node 节点的 variable 信息
  const { globalVariableData } = useExpressionScope()
  // 所有的列字段
  const allFields: TableVariableNodeVariableChild[] =
    globalVariableData?.children || []

  // 设置当前的列字段
  const handleClick = (field: TemplateVariableEntity) => {
    const nodeVariableField = form.values.selectedFields.find(
      item => item.id === field.id
    )
    if (nodeVariableField) {
      form.setValuesIn('currentField', {
        ...nodeVariableField,
        fontStyle: [nodeVariableField.fontWeight].filter(Boolean)
      })
    }
  }

  const checkboxGroupValue = useMemo(() => value.map(item => item.id), [value])

  const setCheckboxGroupValue = (value: string[]) => {
    onChange?.(allFields.filter(item => item.id && value.includes(item.id)))
  }

  const { styles } = useStyles()

  return (
    <Checkbox.Group
      {...formilyProps}
      value={checkboxGroupValue}
      onChange={setCheckboxGroupValue}
    >
      {allFields.map(field => (
        <Flex key={`${field.id}`} align='center' gap={0}>
          <Checkbox value={field.id} />
          <Button
            className={styles.button}
            type='text'
            onClick={() => handleClick(field)}
          >
            {field.name}
          </Button>
        </Flex>
      ))}
    </Checkbox.Group>
  )
}

export const FieldCheckboxGroup = connect(
  Component,
  mapReadPretty(Component, { disabled: true })
)
